import { memo, useState } from "react";

import { Dialog, TableTrips } from "@components";
import ConfirmationDialog from "@rio-cloud/rio-uikit/ConfirmationDialog";

import { Trip } from "@types";
import PageContainer from "../../components/routes/PageContainer";
import { HeaderCards } from "./components/headerCards";
import { useTripsController } from './components/useTripsController';

const TripsScreen = () => {
  const {
    trips,
    dashboard,
    searchValue,
    openModal,
    filterByType,
    show,
    setSort,
    setFieldSort,
    handleOpenModal,
    handleCloseModal,
    handleUpdateRoute,
    handleSelectTrip,
    handleSelectFileModel,
    handleShowTripDetails,
    handleDownload,
    handleSchedulingActionDate,
    setShow,
    setIdDelete,
    handleCanceled,
    handleSelectTripFilterByType,
    handlePage,
    handleDateFilterChange,
    handleSearchValueChange,
    handleResetPage,
    totalSize,
    size,
    handleResetDate,
    isLoading,
    handleSelectNewRoute
  } = useTripsController();

  const [tripDriversModal, setTripDriversModal] = useState<Trip | null>(null);

  const handleShowDrivers = (trip: Trip) => setTripDriversModal(trip);
  const handleCloseDriversModal = () => setTripDriversModal(null);

  return (
    <PageContainer>
      <HeaderCards
        filterByType={filterByType}
        dashboard={dashboard}
        handleSelectTripFilterByType={handleSelectTripFilterByType}
      />
      <TableTrips
        isLoading={isLoading}
        handleResetDate={handleResetDate}
        handleResetPage={handleResetPage}
        size={size}
        totalSize={totalSize}
        handleDownload={handleDownload}
        handleSort={(dir, field) => {
          setSort({ [field]: dir });
          setFieldSort(field);
        }}
        routes={trips}
        viewType="TABLE"
        handleCreateRoute={handleOpenModal}
        handleUpdateRoute={handleUpdateRoute}
        handleSearchValueChange={handleSearchValueChange}
        searchValue={searchValue}
        handleScheduleAccept={(id) => handleSchedulingActionDate("ACCEPT", id)}
        handleScheduleRefused={(id) => handleSchedulingActionDate("REFUSE", id)}
        handleCancel={(id) => {
          setIdDelete(id);
          setShow(true);
        }}
        handleShowTripDetail={handleShowTripDetails}
        handleShowDrivers={handleShowDrivers}
        handlePage={params => handlePage(params)}
        onDateFilterChange={handleDateFilterChange}
      />
      <ConfirmationDialog
        show={show}
        title="Confime o Cancelamento"
        content="Tem certeza que deseja cancelar a viagem?"
        onClickConfirm={handleCanceled}
        onClickCancel={() => setShow(false)}
        cancelButtonText="Voltar"
        confirmButtonText={<span>Confirmar</span>}
        useOverflow
      />
      <Dialog.AddTrip
        open={openModal}
        onClose={handleCloseModal}
        onClickSelectRoute={handleSelectTrip}
        handleSelectFileModel={handleSelectFileModel}
        handleSelectNewRoute={handleSelectNewRoute}
      />
      <Dialog.DispatchedDrivers
        open={tripDriversModal !== null}
        onClose={handleCloseDriversModal}
        drivers={tripDriversModal?.dispatchedDrivers}
      />
    </PageContainer>
  );
};

export default memo(TripsScreen);